/**
 * @description 浏览器相关方案集合
 * @author shuowang13
 * @time 20231109
 */
// 是否是可触屏设备（手机、pad、电视）
export const isIpad = () => {
  if (navigator.userAgent.match(/iPad|iPhone/i)) {
    return true
  } else {
    return false
  }
}
// 是否是移动端设备
export const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent)
// 是否是chrome浏览器包含移动端chrome
export const isChrome = () => {
  const userAgent = navigator.userAgent
  if (
    (userAgent.indexOf('Chrome') !== -1 &&
      userAgent.indexOf('Safari') !== -1 &&
      userAgent.indexOf('Edg') === -1) ||
    userAgent.indexOf('CriOS') !== -1
  ) {
    return true // Chrome包含移动端chrome
  } else if (userAgent.indexOf('Firefox') !== -1) {
    return false // Firefox
  } else if (
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1 &&
    userAgent.indexOf('Edge') === -1
  ) {
    return false // Safari
  } else if (userAgent.indexOf('Edg') !== -1) {
    return false // Edge
  } else {
    return false // 其他浏览器...
  }
}
